import { Editor, Extension } from '@tiptap/core';
import { BASE_URL } from '../../../util/env-helper';
import { UploadService } from '../../../service/upload.service';

export const FileUploadExtension = Extension.create({
  name: 'customFileUpload',

  addOptions() {
    return {
      endpoint: `${BASE_URL}ck-upload`,
    };
  },

  addCommands() {
    return {
      uploadImage:
        () =>
        ({ editor }: { editor: Editor }) => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.click();

          input.onchange = async () => {
            const file = input.files?.[0];
            if (!file) return;

            try {
              const imageUrl = await uploadImageToServer(
                file,
                this.options.endpoint,
              );
              if (imageUrl) {
                editor
                  .chain()
                  .focus()
                  .insertContent({
                    type: 'image',
                    attrs: {
                      src: imageUrl,
                      width: '300px',
                    },
                  })
                  .run();
              }
            } catch (err) {
              console.error('Image upload failed', err);
            }
          };

          return true;
        },
    };
  },
});

async function uploadImageToServer(
  file: File,
  uploadUrl: string,
): Promise<string | null> {
  return new Promise(async (resolve, reject) => {
    const [res, err] = await UploadService.upload(file);
    if (err || !res?.success) {
      reject(
        err?.message || res?.message || `Couldn't upload file: ${file.name}`,
      );
      return;
    }
    resolve(res.data.url?.default || null);
  });
}
